import { paths } from '@/constants'

export const buildSignupUrl = (returnTo: string): string => {
  const hashed = Buffer.from(returnTo, 'utf-8').toString('base64')
  return `${paths.auth.signup}?returnTo=${hashed}`
}
